<template>
  <bim-container class="mt-12 pt-5">
    <bimTextH4 type="h1" bold class="mb-6 cases-list__title">Наши кейсы</bimTextH4>
    <bimTextMedium class="mb-10 mb-md-12 cases-list__title-desc">Реализованные проекты, которые уже приносят прибыль собственникам бизнеса:</bimTextMedium>

    <preloader v-if="loading" />

    <div v-else class="d-flex flex-wrap cases__container">

      <div class="cases-list__wrapper">
        <OneCaseCard
          class="mb-10"
          v-for="_case in slicedCases.before"
          :key="_case.id"
          :data="_case"
        />
      </div>

      <ThanksgivingLetters class="mb-10" />

      <div class="cases-list__wrapper">
        <OneCaseCard
          class="mb-10"
          v-for="_case in slicedCases.after"
          :key="_case.id"
          :data="_case"
        />

        <div class="case__link-wrapper">
          <div class="case__container case__get-order p-0">
            <bimTextMedium>Хотите также?</bimTextMedium>
            <bimTextMain bold class="mt-2 mb-9">Сделайте заказ сейчас</bimTextMain>
            <bimButton v-metric="'LENDING-BIM_CLICK-ON-SEND-REQUEST-TO-BUY-TARIFF'" class="open-modal" data-modal="sendPhone" label="Сделать заказ" @click="showPhonePopup = true" />
          </div>
        </div>
      </div>

    </div>

    <bimPhoneRequest
      v-model="showPhonePopup"
      :userContext="user_info"
      :logActionEvent="$logActionEvent"
      apiPrefix="/web-api-2"
    />

  </bim-container>
</template>

<script>
import ThanksgivingLetters from "./ThanksgivingLetters"
import OneCaseCard from "./OneCaseCard"

import bimPhoneRequest from '@bimlib/components/bimPhoneRequest'
import bimPopup from "@bimlib/components/bimPopup"
import bimButton from "@bimlib/components/bimButton"
import bimContainer from "@bimlib/components/bimContainer"
import bimTextH4 from "@bimlib/components/bimTextH4"
import bimTextMain from "@bimlib/components/bimTextMain"
import bimTextMedium from "@bimlib/components/bimTextMedium"

import breakpoint from "@/mixins/breakpoint"

export default {
  name: "cases",
  mixins: [breakpoint],
  components: {
    ThanksgivingLetters,
    OneCaseCard,

    bimPhoneRequest,
    bimPopup,
    bimButton,
    bimContainer,
    bimTextH4,
    bimTextMain,
    bimTextMedium,
  },
  data() {
    return {
      cases: null,
      showPhonePopup: false,
    }
  },
  props: {
    user_info: Object,
  },
  async created() {
    const cases = await this.$store.dispatch('getCasesList')
    this.cases = cases.filter(c => c.lang_versions[1].status_lang === "Published")
  },
  computed: {
    loading() {
      return this.$store.getters.getCasesLoading
    },
    slicedCases() {
      const cases = {
        before: [],
        after: [],
      }

      if (!this.cases) return cases

      const sliceCount = this.ww > 1278 ? 3 : 2

      cases.before = this.cases.slice(0, sliceCount)
      cases.after = this.cases.slice(sliceCount)

      return cases
    }
  },
}
</script>
